import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewCategoryList = () => {
  return useQuery({
    queryKey: ["viewcategorylist"],
    queryFn: async () => {
      const res = await api.get("/categories/list");
      return res.data;
    },
  });
};
